/**
 * 現地
 */
import Vue from "vue";
import * as types from "../../../mutation-types/backyard-types";
import * as httpConst from "../../../../constants/httpConst";

const API_PATH = `${httpConst.BACKYARD_ENDPOINT}/search/local_places`

const local_place = {
    namespaced: true,
    state: {
        content: [],
    },
    getters: {},
    actions: {
        fetch({ commit }) {

            return new Promise((resolve, _reject) => {
                Vue.$http.get(API_PATH).then(data => {
                    let content = data.content
                    commit(types.BACK_SEARCH_LOCAL_PLACE, { content })
                    resolve(content)
                })
            })
        }
    },
    mutations: {
        [types.BACK_SEARCH_LOCAL_PLACE] (state, { content }) {
            console.log(content)
            state.content = content
        },
    },
}

export default local_place
